import React, { Component } from "react";
import NumberFormat from "react-number-format";

/**
 * This component will return input element masked with dollary symbol
 */
class PromoSpendInputMasking extends Component {
  render() {
    const value = this.props.value;

    return (
      <NumberFormat
        data-name={this.props.name}
        data-client-id={this.props.clientId}
        data-promo-id={this.props.promoId}
        data-product-id={this.props.productId}
        value={value}
        prefix="$"
        thousandSeparator=","
        onChange={this.props.onChange}
      />
    );
  }
}

export default PromoSpendInputMasking;



// WEBPACK FOOTER //
// ./src/components/promo-spend/PromoSpendInputMasking.js